import * as types from '../mutation-types'
import { FATE_DATA_MANAGER, COMMENT_DATA_MANAGER } from '../../data'

export default {
    namespaced: true,
    state: {
        showTypeList: ['dayun', 'liunian', 'liuyue', 'liuri', 'liushi'],
        fateInfo: {},
        fateListData: [],
        fateSideListData: [],
        fortuneTitle: '',
        fortuneListData: [],
        fortuneBeforeListData: [],
        showLeftArrow: false,
        showRightArrow: false,
        showTable: 10,
        showLines: 1,
        showTitle: false,
        showType: 'dayun',
        addedFortuneListData: false,
        curDaYun: {},
        curScrollYId: '',
        hasDeleteAllData: false,
        liunianListData: [],
        liuyueListData: [],
        liuriListData: [],
        liushiListData: []
    },
    getters: {},
    mutations: {
        // 批盘页:mini命盘+运盘:数据操作
        [types.PLUGIN_INIT_COMMENT_MINI_FATE_FORTUNE_DATA](state, data) {
            // 从命盘页过来的直接取命盘页的相关数据，不用重新走PAIPAN
            // console.log('types.PLUGIN_INIT_COMMENT_MINI_FATE_FORTUNE_DATA------', data)
            var fateData = FATE_DATA_MANAGER.getDetailFateDataByData(data, 'mini');
            state.fateInfo = fateData.fateInfo;
            state.detailInfoData = fateData.detailInfo;

            state.showTable = 10;
            state.fateListData = fateData.fateListData;
            state.fortuneListData = fateData.fortuneListData;
            state.fortuneBeforeListData = fateData.beforeListData;
            
            // 处理当前大运
            var resultData = fateData.fortuneListData.filter(data => {return data.current});
            state.curDaYun = resultData[0];
            // state.showType = 'liunian';
            // AppFate.$store.dispatch('minifatefortune/showMiniLiuNian', state.curDaYun);
        },
        [types.PLUGIN_INIT_MINI_FATE_SIDE_ADD](state, data) {
            var originData = state.fateSideListData;
            var resultData = {}, maxLength = state.showTypeList.indexOf(data.type) + 1;
            // state.showLines = 2;
            // 检查当前:10列:是上一级别的话，就更新数据不操作dom
            if(data.type != 'liushi'){
                if(originData.length >= maxLength) {
                    resultData = FATE_DATA_MANAGER.updateFateSideData('', originData, data);
                }else{
                    resultData = FATE_DATA_MANAGER.addFateSideData('', originData, data);
                }
                state.fateSideListData = resultData.data;
            }

            // 更新当前选中状态
            switch(data.type){
                case 'dayun':
                    state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, data);
                    break;
                case 'liunian':
                    state.liunianListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liunianListData, data);
                    break;
                case 'liuyue':
                    state.liuyueListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liuyueListData, data);
                    break;
                case 'liuri':
                    state.liuriListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liuriListData, data);
                    break;
                case 'liushi':
                    state.liushiListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liushiListData, data);
                    break;
                default:
                    break;
            }

        },
        [types.PLUGIN_INIT_MINI_FATE_SIDE_DELETE](state, data) {
            var originData = state.fateSideListData;
            var resultData = FATE_DATA_MANAGER.deleteFateSideData('', originData, data);
            // console.log('deeeeeeeeeeeeeeeelete------', state.showTable, data.type, state.fortuneListData, state.liunianListData)
            state.showType = resultData.type;
            state.fateSideListData = resultData.data;

            // 特殊处理:十列的时候要做处理
            if(data.type == 'dayun') {
                state.fortuneListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.fortuneListData, {id: 0})
                state.showType = 'dayun';
                state.liunianListData = [];
                // state.showLines = 1;
                // state.liunianListData = FATE_DATA_MANAGER.updateFortuneListDataChoosed(state.liunianListData, {id: 0})
                // AppFate.$store.dispatch('minifatefortune/showMiniLiuNian', state.curDaYun);
            }
            if(state.showType == 'dayun') {
                state.showLeftArrow = false; state.showRightArrow = false;
            }else {
                state.showLeftArrow = state.fateSideListData[0].index == 0 ? false : true; 
                state.showRightArrow = state.fateSideListData[0].index == 9 ? false : true;
            }
            // console.log('types.PLUGIN_INIT_MINI_FATE_SIDE_DELETE----', data);
        },
        [types.PLUGIN_INIT_MINI_SHOW_LIUNIAN](state, data) {
            state.showType = "liunian";
            // 处理传入参数
            var titleStr = data.title[0], ageStr = titleStr.split('/')[1];
            var yearData = {
                startAge: parseInt(ageStr),
                yearNum: data.year
            };
            if(data.typeBefore) {
                state.liunianListData = [].concat(state.fortuneBeforeListData);
                state.liunianListData.reverse();
            }else {
                state.liunianListData = FATE_DATA_MANAGER.getFortuneLiuNianDataByYear(state.fateInfo, yearData, 'comment');
            }
            state.showLeftArrow = state.fateSideListData[0].index == 0 ? false : true; 
            state.showRightArrow = state.fateSideListData[0].index == state.liunianListData.length - 1 ? false : true;

            // 处理流年列表数据的批盘编辑状态
            var commentDaYunLiuNianList = AppFate.$store.state.comment.dayunLiunianList;
            if(commentDaYunLiuNianList.length > 0) {
                state.liunianListData = COMMENT_DATA_MANAGER.getMiniPanLiunianListByList(state.liunianListData, commentDaYunLiuNianList, data.year);
            }
            // 处理流年列表数据的编辑状态
            var pediaDayunLiunianList = AppFate.$store.state.famouspedia.curPediaDayunLiunianList;
            if(pediaDayunLiunianList.length > 0) {
                state.liunianListData = COMMENT_DATA_MANAGER.getMiniPanLiunianListByList(state.liunianListData, pediaDayunLiunianList, data.year);
            }

            setTimeout(() => {
                AppFate.$bus.emit('updateFortuneLiuNian');
            }, 20);
            console.log("types.DETAIL_SHOW_LIUNIAN", data, yearData, state.liunianListData);
        },
        [types.PLUGIN_INIT_MINI_SHOW_LIUYUE](state, yearNum) {
            state.showType = "liuyue";
            state.liuyueListData = FATE_DATA_MANAGER.getFortuneLiuYueDataByYear(state.fateInfo, yearNum, 'comment');
            state.showLeftArrow = state.fateSideListData[1].index == 0 ? false : true; 
            state.showRightArrow = state.fateSideListData[1].index == (state.fortuneBeforeListData.length > 0 && state.fateSideListData[0].index == 0 ? state.fortuneBeforeListData.length - 1 : 9) ? false : true;
            // console.log("types.DETAIL_SHOW_LIUYUE", yearNum, state.liuyueListData, state.fateSideListData[1].index);
        },
        [types.PLUGIN_INIT_MINI_SHOW_LIURI](state, yueTime) {
            state.showLeftArrow = state.fateSideListData[2].index == 0 ? false : true; 
            state.showRightArrow = state.fateSideListData[2].index == state.liuyueListData.length - 1 ? false : true;
            state.showType = "liuri";
            state.liuriListData = FATE_DATA_MANAGER.getFortuneLiuRiDataByYear(state.fateInfo, yueTime);
            // console.log("types.DETAIL_SHOW_LIURI", yueTime, state.liuriListData);
        },
        [types.PLUGIN_INIT_MINI_SHOW_LIUSHI](state, shiTime) {
            state.showLeftArrow = state.fateSideListData[3].index == 0 ? false : true; 
            state.showRightArrow = state.fateSideListData[3].index == state.liuriListData.length - 1 ? false : true;
            state.showType = "liushi";
            state.liushiListData = FATE_DATA_MANAGER.getFortuneLiuShiDataByYear(state.fateInfo, shiTime);
            // console.log("types.DETAIL_SHOW_LIUSHI", shiTime, state.liushiListData);
        },
        [types.PLUGIN_INIT_TOGGLE_ARROW_CHANGE_SHOW_LINES](state) {
            // console.log('types.PLUGIN_INIT_TOGGLE_ARROW_CHANGE_SHOW_LINES------', state.showLines)
            state.showLines = state.showLines == 1 ? 0 : 1;
            
            if(state.showLines == 0) {
                state.showLeftArrow = false; state.showRightArrow = false;
            }else if(state.showLines == 1){
                switch(state.showType) {
                    case 'liunian':
                        state.showLeftArrow = state.fateSideListData[0].index == 0 ? false : true; 
                        state.showRightArrow = state.fateSideListData[0].index == 9 ? false : true;
                        break;
                    case 'liuyue':
                        state.showLeftArrow = state.fateSideListData[1].index == 0 ? false : true; 
                        state.showRightArrow = state.fateSideListData[1].index == 9 ? false : true;
                        break;
                    case 'liuri':
                        state.showLeftArrow = state.fateSideListData[2].index == 0 ? false : true; 
                        state.showRightArrow = state.fateSideListData[2].index == state.liuyueListData.length - 1 ? false : true;
                        break;
                    case 'liushi':
                        state.showLeftArrow = state.fateSideListData[3].index == 0 ? false : true; 
                        state.showRightArrow = state.fateSideListData[3].index == state.liuriListData.length - 1 ? false : true;
                        break;
                    default:
                        break;
                }
            }
        },
        [types.PLUGIN_INIT_COMMENT_TRIGGER_FORTUNE_ITEM_CLICK](state, data) {
            console.log('types.PLUGIN_INIT_COMMENT_TRIGGER_FORTUNE_ITEM_CLICK------', data, state.fortuneBeforeListData)
            if(data.indexOf('dayun') != -1){
                var dayunArr = data.split('dayun'), yearNum1 = parseInt(dayunArr[1]);
                var dayunData = FATE_DATA_MANAGER.getFortuneItemDataByYear(state.fortuneListData, yearNum1);
                // console.log('dayun--------', yearNum1, state.fortuneListData, dayunData)
                if(!dayunData) { return; }
                AppFate.$store.dispatch("minifatefortune/addMiniFateSide", dayunData);
                if(state.fortuneBeforeListData.length > 0 && yearNum1 == state.fortuneBeforeListData[0].year) {
                    AppFate.$store.dispatch('minifatefortune/showMiniBefore', data);
                }else {
                    AppFate.$store.dispatch('minifatefortune/showMiniLiuNian', dayunData);
                }
            }else if(data.indexOf('liunian') != -1) {
                var liunianArr = data.split('liunian'), yearNum2 = parseInt(liunianArr[1]);
                var liunianData = FATE_DATA_MANAGER.getFortuneItemDataByYear(state.liunianListData, yearNum2);
                // console.log('liunian--------', yearNum2, state.liunianListData, liunianData)
                if(!liunianData) { return; }
                AppFate.$store.dispatch("minifatefortune/addMiniFateSide", liunianData);
                AppFate.$store.dispatch('minifatefortune/showMiniLiuYue', liunianData.year);
            }
        },
        [types.PLUGIN_INIT_RESET_MINI_FATE_FORTUNE_DATA](state) {
            // 重置数据
            state.fateInfo = {};
            state.fateListData = [];
            state.fateSideListData = [];
            state.fortuneListData = [];
            state.fortuneSideListData = [];
            state.showLeftArrow = false;
            state.showRightArrow = false;
            state.showTitle = false;
            state.showType = 'dayun';
            state.addedFortuneListData = false;
            state.showLines = 1;
            state.curDaYun = {};
            state.curScrollYId = '';
            state.hasDeleteAllData = false;
            state.liunianListData = [];
            state.liuyueListData = [];
            state.liuriListData = [];
            state.liushiListData = [];
        }
    },
    actions: {
        initCommentMiniFateFortune({ commit }, data) {
            commit(types.PLUGIN_INIT_COMMENT_MINI_FATE_FORTUNE_DATA, data)
        },
        addMiniFateSide({ commit }, data) {
            commit(types.PLUGIN_INIT_MINI_FATE_SIDE_ADD, data)
        },
        deleteMiniFateSide({ commit }, data) {
            commit(types.PLUGIN_INIT_MINI_FATE_SIDE_DELETE, data)
        },
        showMiniBefore({ state }, data) {
            state.showType = "liunian";
            // 处理箭头状态
            state.showLeftArrow = state.fateSideListData[0].index == 0 ? false : true; 
            state.showRightArrow = state.fateSideListData[0].index == state.fortuneBeforeListData.length - 1 ? false : true;

            // 处理流年列表数据的批盘编辑状态
            var commentDaYunLiuNianList = AppFate.$store.state.comment.dayunLiunianList;
            if(commentDaYunLiuNianList.length > 0) {
                state.fortuneBeforeListData = COMMENT_DATA_MANAGER.getMiniPanLiunianListByList(state.fortuneBeforeListData, commentDaYunLiuNianList, data.year);
            }
            // 处理流年列表数据的编辑状态
            var pediaDayunLiunianList = AppFate.$store.state.famouspedia.curPediaDayunLiunianList;
            if(pediaDayunLiunianList.length > 0) {
                state.fortuneBeforeListData = COMMENT_DATA_MANAGER.getMiniPanLiunianListByList(state.fortuneBeforeListData, pediaDayunLiunianList, data.year);
            }
            // 处理完状态之后再反向
            state.liunianListData = [].concat(state.fortuneBeforeListData);
            state.liunianListData.reverse();
            
            setTimeout(() => {
                AppFate.$bus.emit('updateFortuneLiuNian');
            }, 20);
        },
        showMiniLiuNian({ commit }, data) {
            commit(types.PLUGIN_INIT_MINI_SHOW_LIUNIAN, data)
        },
        showMiniLiuYue({ commit }, data) {
            commit(types.PLUGIN_INIT_MINI_SHOW_LIUYUE, data)
        },
        showMiniLiuRi({ commit }, data) {
            commit(types.PLUGIN_INIT_MINI_SHOW_LIURI, data)
        },
        showMiniLiuShi({ commit }, data) {
            commit(types.PLUGIN_INIT_MINI_SHOW_LIUSHI, data)
        },
        toggleArrowChangeShowLines({ commit }) {
            commit(types.PLUGIN_INIT_TOGGLE_ARROW_CHANGE_SHOW_LINES)
        },
        triggerFortuneItemClick({ commit }, data) {
            commit(types.PLUGIN_INIT_COMMENT_TRIGGER_FORTUNE_ITEM_CLICK, data)
        },
        addFortuneListData({ state }, params) {
            if(state.addedFortuneListData) { 
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            var tempData = {}, listData = [], curListData = [], tempList = [], temptempData, curIndex;
            switch(params.dataType) {
                case 'liunian':
                    tempData = state.fateSideListData[0]; curIndex = tempData.index;
                    listData = state.fortuneListData; curListData = state.liunianListData;
                    if(params.type == 'previous') {
                        temptempData = curIndex > 0 ? listData[curIndex - 1] : temptempData;
                    }else if(params.type == 'next') {
                        temptempData = curIndex < 9 ? listData[curIndex + 1] : temptempData; 
                    }
                    if(!temptempData) { return; }
                    var titleStr = temptempData.title[0], ageStr = titleStr.split('/')[1];
                    var yearData = {
                        startAge: parseInt(ageStr),
                        yearNum: temptempData.year
                    };
                    tempList = FATE_DATA_MANAGER.getFortuneLiuNianDataByYear(state.fateInfo, yearData, 'comment');
                    if(params.type == 'previous') {
                        state.liunianListData = tempList.concat(curListData);
                    }else if(params.type == 'next') {
                        state.liunianListData = curListData.concat(tempList);
                    }
                    console.log('liunian-----', temptempData, tempList, state.liunianListData)
                    break;
                case 'liuyue':
                    // var tempDayun = state.fateSideListData[0];
                    tempData = state.fateSideListData[1]; curIndex = tempData.index;
                    listData = state.liunianListData; curListData = state.liuyueListData;
                    if(params.type == 'previous') {
                        temptempData = curIndex > 0 ? listData[curIndex - 1] : temptempData;
                    }else if(params.type == 'next') {
                        temptempData = curIndex < listData.length - 1 ? listData[curIndex + 1] : temptempData;
                    }
                    if(!temptempData) { return; }
                    tempList = FATE_DATA_MANAGER.getFortuneLiuYueDataByYear(state.fateInfo, temptempData.year, 'comment');
                    if(params.type == 'previous') {
                        state.liuyueListData = tempList.concat(curListData);
                    }else if(params.type == 'next') {
                        state.liuyueListData = curListData.concat(tempList);
                    }
                    console.log('liuyue-----', tempData, temptempData, tempList, state.liuyueListData)
                    break;
                case 'liuri':
                    tempData = state.fateSideListData[2]; curIndex = tempData.index;
                    listData = state.liuyueListData; curListData = state.liuriListData;
                    if(params.type == 'previous') {
                        temptempData = curIndex > 0 ? listData[curIndex - 1] : temptempData;
                    }else if(params.type == 'next') {
                        temptempData = curIndex < listData.length - 1 ? listData[curIndex + 1] : temptempData; 
                    }
                    if(!temptempData) { return; }
                    tempList = FATE_DATA_MANAGER.getFortuneLiuRiDataByYear(state.fateInfo, temptempData.time, 'comment');
                    if(params.type == 'previous') {
                        state.liuriListData = tempList.concat(curListData);
                    }else if(params.type == 'next') {
                        state.liuriListData = curListData.concat(tempList);
                    }
                    console.log('liuri-----', tempData, temptempData, tempList, state.liuriListData)
                    break;
                case 'liushi':
                    tempData = state.fateSideListData[3]; curIndex = tempData.index;
                    listData = state.liuriListData; curListData = state.liushiListData;
                    if(params.type == 'previous') {
                        temptempData = curIndex > 0 ? listData[curIndex - 1] : temptempData;
                    }else if(params.type == 'next') {
                        temptempData = curIndex < listData.length - 1 ? listData[curIndex + 1] : temptempData; 
                    }
                    if(!temptempData) { return; }
                    tempList = FATE_DATA_MANAGER.getFortuneLiuShiDataByYear(state.fateInfo, temptempData.g, 'comment');
                    if(params.type == 'previous') {
                        state.liushiListData = tempList.concat(curListData);
                    }else if(params.type == 'next') {
                        state.liushiListData = curListData.concat(tempList);
                    }
                    console.log('liushi-----', tempData, temptempData, tempList, state.liuriListData)
                    break;
                default:
                    break;
            }
            console.log('addFortuneListData----', params.dataType, tempData, listData);
            state.addedFortuneListData = true;
            if(params.firstCb && typeof(params.firstCb) == 'function') {
                setTimeout(() => {
                    params.firstCb();
                }, 20);
            }
        },
        resetFortuneListData({ state }, params) {
            console.log('resetFortuneListData----', params)
            state.addedFortuneListData = false;
            switch(params.dataType) {
                case 'liunian':
                    if(state.liunianListData.length < 20) { return; }
                    if(params.type == 'previous') {
                        state.liunianListData.splice(0, 10);
                    }else if(params.type == 'next') {
                        state.liunianListData.splice(10);
                    }
                    break;
                case 'liuyue':
                    if(state.liuyueListData.length < 24) { return; }
                    if(params.type == 'previous') {
                        state.liuyueListData.splice(0, 12);
                    }else if(params.type == 'next') {
                        state.liuyueListData.splice(12);
                    }
                    break;
                case 'liuri':
                    if(state.liuriListData.length < 62) { return; }
                    if(params.type == 'previous') {
                        state.liuriListData.splice(0, 31);
                    }else if(params.type == 'next') {
                        state.liuriListData.splice(31);
                    }
                    break;
                case 'liushi':
                    if(state.liushiListData.length < 26) { return; }
                    if(params.type == 'previous') {
                        state.liushiListData.splice(0, 13);
                    }else if(params.type == 'next') {
                        state.liushiListData.splice(13);
                    }
                    break;
                default:
                    break;
            }
        },
        getNewFortuneItemData({ state }, params) {
            state.addedFortuneListData = false;
            var tempData = {}, newData = {}, listData = [];
            switch(params.dataType) {
                case 'liunian':
                    tempData = state.fateSideListData[0];
                    listData = state.fortuneListData;
                    break;
                case 'liuyue':
                    tempData = state.fateSideListData[1];
                    listData = state.liunianListData;
                    break;
                case 'liuri':
                    tempData = state.fateSideListData[2];
                    listData = state.liuyueListData;
                    break;
                case 'liushi':
                    tempData = state.fateSideListData[3];
                    listData = state.liuriListData;
                    break;
                default:
                    break;
            }
            if(params.type == 'previous') {
                newData = FATE_DATA_MANAGER.getPreviousDataInList(listData, tempData);
            }else if(params.type == 'next') {
                newData = FATE_DATA_MANAGER.getNextDataInList(listData, tempData);
            }
            console.log('getNewFortuneItemData------', newData)
            if(params.cb && typeof(params.cb) == 'function') {
                params.cb(newData);
            }
        },
        triggerFortuneItemFunction({ commit, state }, itemId) {
            var itemData;
                state.curScrollYId = itemId;
            if(itemId.indexOf('dayun') != -1) {
                itemId = itemId.replace('dayun', '');
                if(itemId == state.curScrollYId) {
                    return;
                }
                itemData = FATE_DATA_MANAGER.getFortuneItemDataByItemId(state.fortuneListData, itemId);
                // console.log('dayun-------', itemId, itemData)
                if(itemData) {
                    state.hasDeleteAllData = false;
                    commit(types.PLUGIN_INIT_MINI_FATE_SIDE_ADD, itemData);
                    commit(types.PLUGIN_INIT_MINI_SHOW_LIUNIAN, itemData);
                }
            }else if(itemId.indexOf('liunian') != -1) {
                itemId = itemId.replace('liunian', '');
                if(itemId == state.curScrollYId) {
                    return;
                }
                itemData = FATE_DATA_MANAGER.getFortuneItemDataByItemId(state.liunianListData, itemId);
                // console.log('liunian-------', itemId, itemData)
                if(itemData) {
                    state.hasDeleteAllData = false;
                    commit(types.PLUGIN_INIT_MINI_FATE_SIDE_ADD, itemData);
                    commit(types.PLUGIN_INIT_MINI_SHOW_LIUYUE, itemData.year);
                }else {
                    // 处理往回滚的时候找不到大运数据的时候，大运年份-10，往前找一下；
                    var dayunData = FATE_DATA_MANAGER.getFortuneItemDataByLiunian(state.fortuneListData, itemId);
                    // console.log('dayun-------', dayunData)
                    if(!dayunData) { return; }
                    state.hasDeleteAllData = false;
                    commit(types.PLUGIN_INIT_MINI_FATE_SIDE_ADD, dayunData);
                    commit(types.PLUGIN_INIT_MINI_SHOW_LIUNIAN, dayunData);
                    setTimeout(() => {
                        itemData = FATE_DATA_MANAGER.getFortuneItemDataByItemId(state.liunianListData, itemId);
                        if(!itemData) { return; }
                        commit(types.PLUGIN_INIT_MINI_FATE_SIDE_ADD, itemData);
                        commit(types.PLUGIN_INIT_MINI_SHOW_LIUYUE, itemData.year);
                    }, 0);
                }
            }
        },
        triggerFortuneItemDeleteFunction({ commit, state}, itemId) {
            if(state.hasDeleteAllData) {
                return;
            }
            var itemData;
            if(itemId.indexOf('dayun') != -1) {
                itemId = itemId.replace('dayun', '');
                itemData = FATE_DATA_MANAGER.getFortuneItemDataByItemId(state.fortuneListData, itemId);
                if(itemData) {
                    state.hasDeleteAllData = true;
                    commit(types.PLUGIN_INIT_MINI_FATE_SIDE_DELETE, itemData);
                }
                if(state.fateSideListData.length == 0) {
                    state.curScrollYId = '';
                }
            }
        },
        updateFamousMiniFortuneList({ state }, params) {
            state.fortuneListData = COMMENT_DATA_MANAGER.updateMiniPanDayunListEdited(state.fortuneListData, params.pediaList);
        },
        updateFamousMiniLiunianList({ state }, params) {
            state.fortuneListData = COMMENT_DATA_MANAGER.updateMiniPanDayunListEdited(state.fortuneListData, params.pediaList);
            state.liunianListData = COMMENT_DATA_MANAGER.updateMiniPanLiunianListEdited(state.liunianListData, params.pediaList, params.parentData);
        },
        updateFamousMiniFortuneListCommentStatus({ state }, params) {
            state.fortuneListData = COMMENT_DATA_MANAGER.updateMiniPanDayunCommented(state.fortuneListData, params.pediaList, params.commentData);
        },
        updateFamousMiniLiunianListCommentStatus({ state }, params) {
            state.liunianListData = COMMENT_DATA_MANAGER.updateMiniPanLiunianCommented(state.liunianListData, params.pediaList, params.commentData);
        },
        resetMiniData({ commit }) {
            commit(types.PLUGIN_INIT_RESET_MINI_FATE_FORTUNE_DATA)
        }
    }
}